<template>
  <div class="overlay-toggle">
    <button
      type="button"
      aria-label="Toggle navigation"
      @click.stop="toggleOverlay">
      <slot></slot>
    </button>
  </div>
</template>

<script>
import { mapState } from "vuex";

export default {
  name: "OverlayToggle",
  props: {
    alias: {
      type: String,
      default: "navigation"
    }
  },
  computed: {
    overlay () {
      return this.overlays.find( x => x.alias === this.alias );
    },
    ...mapState( {
      overlays: state => state.overlay.overlays
    } )
  },
  methods: {
    toggleOverlay () {
      const actionName = !this.overlay.open ? "openOverlay" : "closeOverlay";

      const payload = {
        alias: this.alias
      };

      this.$store.dispatch( actionName, payload );
    }
  }
};
</script>

<style lang="less" scoped>

</style>
